import { useState, useEffect } from "react";
import type { AdminOrderData } from "../page";

interface Props {
  order: AdminOrderData;
  onSave: (notes: string) => Promise<void>;
}

export default function AdminOrderNotes({ order, onSave }: Props) {
  const [notes, setNotes] = useState(order.internalNotes ?? "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    setNotes(order.internalNotes ?? "");
    setDirty(false);
  }, [order.internalNotes]);

  const handleSave = async () => {
    setSaving(true);
    await onSave(notes);
    setSaving(false);
    setSaved(true);
    setDirty(false);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-5 flex flex-col gap-3">
      <h3 className="font-bold text-[#1a1a1a] text-sm flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center bg-amber-50 rounded-lg">
          <i className="ri-sticky-note-line text-amber-600 text-sm"></i>
        </div>
        ملاحظات داخلية
        <span className="mr-auto text-[10px] text-gray-400 font-normal bg-gray-100 px-2 py-0.5 rounded-full">
          للفريق فقط
        </span>
      </h3>

      <textarea
        value={notes}
        onChange={e => { setNotes(e.target.value); setDirty(true); setSaved(false); }}
        placeholder="أضف ملاحظات داخلية للفريق... مثل: تم التواصل مع العميل، مشكلة في العنوان، إلخ"
        rows={4}
        maxLength={500}
        className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-[#1a1a1a] outline-none focus:border-[#1a1a1a] transition-colors resize-none placeholder-gray-400 leading-relaxed"
      />

      <div className="flex items-center justify-between">
        <span className="text-[11px] text-gray-400">{notes.length}/500</span>
        <button
          onClick={handleSave}
          disabled={saving || !dirty}
          className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold transition-all cursor-pointer whitespace-nowrap disabled:opacity-40 ${
            saved
              ? "bg-green-50 border border-green-200 text-green-700"
              : "bg-[#1a1a1a] text-white hover:bg-[#333] disabled:cursor-not-allowed"
          }`}
        >
          {saving ? (
            <i className="ri-loader-4-line animate-spin text-sm"></i>
          ) : saved ? (
            <i className="ri-check-double-line text-sm"></i>
          ) : (
            <i className="ri-save-line text-sm"></i>
          )}
          {saved ? "تم الحفظ" : "حفظ"}
        </button>
      </div>
    </div>
  );
}
